import { render } from "./UploadImages.vue?vue&type=template&id=1bebbe0a"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"

import "./UploadImages.vue?vue&type=style&index=0&id=1bebbe0a&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__